import { createAction } from 'redux-actions'
import { SUBMISSION_FAILED, SUBMISSION_STARTED, SUBMISSION_SUCCEEDED } from 'Redux/Types/FormTypes'

export const submissionFailed = createAction(SUBMISSION_FAILED)
export const submissionStarted = createAction(SUBMISSION_STARTED)
export const submissionSucceeded = createAction(SUBMISSION_SUCCEEDED)
